import { ProfileService } from 'client/services';
import { useEffect, useState } from 'react';
import styles from './FeedbackPrompt.module.scss';
import { useIntl } from 'react-intl';
import Button from 'client/components/aria/Button/Button';
import useAuth from 'client/utils/auth/useAuth';
import loader from './FeedbackPrompt.loader';
import { FEEDBACK_PAGE } from 'client/utils/routes/routeConstants';

const FeedbackPrompt = () => {
    const intl = useIntl();
    const { isAuthenticated, user } = useAuth();
    const [hideFeedbackPrompt, setHideFeedbackPrompt] = useState(true);
    const GENERAL = 'GENERAL';

    const onDismiss = () => {
        ProfileService.postUserFeedbackLog(GENERAL, true);
        setHideFeedbackPrompt(true);
    };

    useEffect(() => {
        if (!isAuthenticated || !user) {
            return;
        }
        loader().then(({ lastSubmittedDate }) => {
            const isUserYoungerThanSevenDays = new Date(user.createdDate) > new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
            const hasSubmittedFeedbackWithinThirtyDays = lastSubmittedDate && new Date(lastSubmittedDate.dateOfFeedback) > new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);
            setHideFeedbackPrompt(isUserYoungerThanSevenDays || hasSubmittedFeedbackWithinThirtyDays);
        }).catch(() => {
            setHideFeedbackPrompt(true);
        });
    }, [isAuthenticated, user]);

    return !hideFeedbackPrompt
        ? <div className="govuk-width-container" data-testid="feedback.prompt">
            <div className={styles.feedback}>
                <div className={styles.feedbackPrompt}>
                    <div className={styles.feedbackPromptContent}>
                        <div className={styles.feedbackPromptQuestions}>
                            <div className={styles.feedbackPromptQuestionAnswer}>
                                <h2 className={[styles.feedbackPromptQuestion].join(' ')}>{intl.formatMessage({ id: 'feedbackPrompt.question' })}</h2>
                                <ul className={styles.feedbackOptionList}>
                                    <li className={styles.feedbackOptionListItem}>
                                        <Button className={styles.feedbackButton} to={FEEDBACK_PAGE} elementType='button' variant='transparent' data-testid="feedback.prompt.yes">{intl.formatMessage({ id: 'yes' })}</Button>
                                    </li>
                                    <li className={styles.feedbackOptionListItem}>
                                        <Button className={styles.feedbackButton} onPress={onDismiss} elementType='button' variant='transparent' data-testid="feedback.prompt.no">{intl.formatMessage({ id: 'no' })}</Button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        : null;
};

export default FeedbackPrompt;
